import { t } from '@lingui/core/macro';
import { Box } from '@pocketlaw/tetris';
import { useField } from 'formik';
import { TextField } from 'shared/domains/forms';
import { getFieldLabel } from '../../../utils/metadataProperties';
import { ConfigMenu } from '../ConfigMenu';
import { SelectDataPoint } from '../SelectDataPoint';
import { FieldInputContainer } from '../styled';
export function TopHitsInput(props) {
    const { pathBase, remove } = props;
    const currentPath = `${pathBase}.topHitsInput`;
    const [field] = useField(currentPath);
    const { orderBy, size } = field.value;
    const [selectedFieldKey] = Object.keys((orderBy === null || orderBy === void 0 ? void 0 : orderBy[0]) || {});
    return (<FieldInputContainer>
      <SelectDataPoint label={t({ message: 'Top hits', comment: 'Insights widget form: Field' })} selectedValue={getFieldLabel(selectedFieldKey)} name={pathBase} onRemove={remove}/>

      <ConfigMenu label={t({ message: 'Config', comment: 'Insights: Top hits configuration' })} secondary={size ? `${size}` : undefined}>
        <Box flexDirection="column" p="sm">
          <TextField name={`${currentPath}.size`} label="Size" type="number"/>
        </Box>
      </ConfigMenu>
    </FieldInputContainer>);
}
